import {
  CONSENT_STATUS,
  CONSENT_STATUS_MAPPER,
} from '../../../../../constants/consentStatus';

import { formatDate } from '../../../../PatientHealthboard/utils';

const DATE_FORMAT = 'MMM D, Y';

export const getConsentStatus = ({
  status,
  expiresAt,
  formatMessage,
  statusChangedAt,
}) => {
  const statusText = formatMessage(
    status
      ? { id: CONSENT_STATUS_MAPPER[status] }
      : { id: 'documentation.consent.active' },
  );

  return status === CONSENT_STATUS.ACTIVE
    ? `${statusText}. Expiring on ${formatDate(expiresAt, DATE_FORMAT)}`
    : `${statusText} on ${formatDate(statusChangedAt, DATE_FORMAT)}`;
};



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/ProfileDocumentation/RenderViewConsents/ViewConsent/helpers.js